import { Divider, Space } from 'antd'
import { FC } from 'react'
import { useCountdown } from '../../../../hook'
import { BitazzaText } from '../../../../components'
import Styles from './Info.module.scss'
import { useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { formattedTime } from '../../../../hook/useCountDown'

interface Props {
    seasonTitle?: string
    startDate: Date | string
    seasonStatus: string
}

export const Info: FC<Props> = ({ seasonTitle, startDate, seasonStatus }) => {
    const { t } = useTranslation()
    const [searchParams] = useSearchParams()

    const { time, timerLabel } = useCountdown(new Date(startDate))

    const [days, hours, minutes, seconds] = time

    return (
        <div>
            <Space
                direction="vertical"
                align="center"
                className={Styles.header}
            >
                <BitazzaText
                    content={t('txt_trading_simulator')}
                    format="t28"
                    bold
                    color="#F1D87E"
                    letterSpacing={2}
                />
                {seasonTitle && (
                    <BitazzaText
                        content={seasonTitle?.toUpperCase()}
                        format="t28"
                        color="#FFFFFF"
                        letterSpacing={2}
                        textAlign="center"
                    />
                )}
            </Space>

            {(searchParams.get('status') !== 'running' ||
                seasonStatus !== 'running') && (
                <>
                    <Divider className={Styles.divider} />
                    <Space
                        direction="vertical"
                        align="center"
                        className={Styles.space}
                    >
                        <BitazzaText
                            content={t('txt_start_in')}
                            format="t16"
                            color="#fff"
                            bold
                            letterSpacing={2}
                            display="block"
                        />
                        {new Date(startDate) > new Date() ? (
                            <BitazzaText
                                strong
                                content={`${
                                    days > 0 ? `${formattedTime(days)}:` : '00:'
                                }${
                                    hours > 0
                                        ? `${formattedTime(hours)}:`
                                        : '00:'
                                }${formattedTime(minutes)}${
                                    days < 0
                                        ? `: ${formattedTime(seconds)}`
                                        : ''
                                }`}
                                format="t40"
                                color="#F1D87E"
                                lineHeight={18}
                                display="block"
                            />
                        ) : (
                            <BitazzaText
                                strong
                                content={`00:00:00`}
                                format="t40"
                                color="#F1D87E"
                                lineHeight={18}
                                display="block"
                            />
                        )}

                        <BitazzaText
                            strong
                            content={timerLabel.toUpperCase()}
                            format="t14"
                            color="#FFFFFF"
                            lineHeight={18}
                            display="block"
                        />

                        <BitazzaText
                            content={t('txt_start_des')}
                            format="t16"
                            color="#86A1A1"
                            textAlign="center"
                        />
                    </Space>
                </>
            )}
        </div>
    )
}
